import {combineReducers} from 'redux';
import accessToken from './accessToken';
import standaloneSMS from './standaloneSMS';

export default combineReducers({
  accessToken,
  standaloneSMS
});
